import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { ArrowRightSmall, Xmark } from '@peacecover/icon';
import RainbowHeartIcon from '../../my-page/my-page-test-icon/RainbowHeartIcon';

interface LoungeNctWishBannerProps {
  onClose: () => void;
  isWishLounge: boolean;
}

const LoungeNctWishBanner = ({ onClose, isWishLounge }: LoungeNctWishBannerProps) => {
  const navigate = useNavigate();
  const handleNavigateToWishZone = () => {
    navigate('/lounge-chat?categoryGroup=nctwish');
  };

  if (isWishLounge) {
    return (
      <div
        className="p-[1px] rounded-[12px] shadow-[0_0_4px_0_rgba(0,0,0,0.05),_0_0_11.6px_0_rgba(0,0,0,0.05)] mx-[8px]"
        style={{
          background:
            'conic-gradient(from 180deg at 50% 50%, #5CD2FF 0deg, #E37EE2 120.6000030040741deg, #FFDF76 246.60000085830688deg, #76D2B6 360deg)'
        }}
      >
        <div className="flex items-center justify-between bg-background-elevated rounded-[11px] px-[14px] py-[12px]">
          <div className="flex items-center gap-[6px]">
            <RainbowHeartIcon size={20} />
            <p className="text-[13px] font-medium text-text-main-lv3 leading-[16px]">
              {t('LoungeChatPage.onlyWishzen')}
            </p>
          </div>
          <button type="button" onClick={onClose}>
            <Xmark size={14} className="text-text-main-lv3" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between bg-background-elevated rounded-[11px] pl-[16px] pr-[13px] py-[12px] shadow-[0_0_4px_0_rgba(0,0,0,0.05),_0_0_11.6px_0_rgba(0,0,0,0.05)] mx-[8px]">
      <button
        type="button"
        className="flex items-center gap-[6px]"
        onClick={handleNavigateToWishZone}
      >
        <img
          src="/assets/icons/star_banner_icon.png"
          alt="star banner icon"
          className="w-[20px] h-[20px]"
        />
        <p className="text-[13px] font-semibold text-on-success leading-[16px]">
          {t('LoungeChatPage.openWishzenLounge')}
        </p>
        <ArrowRightSmall size={16} className="text-on-success" />
      </button>
      <button type="button" onClick={onClose}>
        <Xmark size={14} className="text-text-main-lv3" />
      </button>
    </div>
  );
};

export default LoungeNctWishBanner;
